import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { InstrumentDetailFacade } from '@zero/instrument-details/domain';
import { CopyToClipboardComponent, DividerComponent, IconComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'instrument-details-derivative-base-and-key-data',
  imports: [AsyncPipe, DividerComponent, IconComponent, NgTemplateOutlet, TranslocoPipe, CopyToClipboardComponent],
  templateUrl: './derivative-base-and-key-data.component.html',
})
export class DerivativeBaseAndKeyDataComponent {
  public readonly facade = inject(InstrumentDetailFacade);
}
